import Page from '@/components/Page'
import { PostActionsProvider } from '@/components/Post/PostActionsContext'
import PostList from '@/components/Post/PostList'
import { COLLETION_POSTS_QUERY_OPTIONS } from '@/utils/fetchers/post'
import usePosts from '@/utils/hooks/usePosts'
import { prepareToRefetchListQuery } from '@/utils/list'
import { useSuspenseInfiniteQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useCallback, useMemo } from 'react'
import { useTitle } from 'react-use'

export const Route = createFileRoute('/u/$username/collection')({
	component: CollectionsPage,
})

function CollectionsPage() {
	const { data, fetchNextPage, refetch, isFetching } = useSuspenseInfiniteQuery(
		COLLETION_POSTS_QUERY_OPTIONS
	)
	const postIds = useMemo(() => data.pages.flatMap((page) => page.data), [data.pages])
	const posts = usePosts(postIds)

	const refresh = useCallback(() => {
		prepareToRefetchListQuery(COLLETION_POSTS_QUERY_OPTIONS.queryKey)
		return refetch()
	}, [refetch])

	useTitle(`收藏 - 即刻`)

	return (
		<Page onReachPageBottom={fetchNextPage}>
			<PostActionsProvider
				value={{
					refresh,
				}}
			>
				<PostList data={posts} isFetching={isFetching} />
			</PostActionsProvider>
		</Page>
	)
}
